<template>
  <Catalogs
    title="Статусы объекта"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'LocationStatusAdd'"
    :route-edit="'LocationStatusEdit'"
    :route-view="'LocationStatusView'"
    :route-path="'/location_statuses'"
    :can-edit="canEditLocationStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "LocationStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'location-status-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'location-status-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getLocationStatuses(data);
    },
    canEditLocationStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_LOCATION_STATUS_EDIT]);
    }
  }
}
</script>

<style>
.location-status-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.location-status-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LocationStatuses/LocationStatuses.vue